import BaseServiceCrud from './BaseServiceCrud';

export default class StartPageService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'start-page';
    }

    getNewsfeed() {
		return this.fetch(`${this.domain}/${this.path}/get-newsfeed`, {
			method: 'GET',
		}).then((res) => {
			return Promise.resolve(res);
		});
	}

    getOfferForYou() {
		return this.fetch(`${this.domain}/${this.path}/get-offer-for-you`, {
			method: 'GET',
		}).then((res) => {
			return Promise.resolve(res);
		});
	}

	getPragmaBanner() {
		return this.fetch(`${this.domain}/${this.path}/get-pragma-banner`, {
			method: 'GET',
		}).then((res) => {
			return Promise.resolve(res);
		});
	}

	getBanners() {
		return this.fetch(`${this.domain}/${this.path}/get-banners`, {
			method: 'GET',
		}).then((res) => {
			return Promise.resolve(res);
		});
	}
}
